/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<a4db267478eab4e38c48285225233dfc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement$data = {
  readonly suggestedRequestTypes: ReadonlyArray<{
    readonly iconUrl: string | null | undefined;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"recentFormsListItem_on_RequestForm">;
  }> | null | undefined;
  readonly " $fragmentType": "suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement";
};
export type suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement$key = {
  readonly " $data"?: suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement$data;
  readonly " $fragmentSpreads": FragmentRefs<"suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutRequestForm",
      "kind": "LinkedField",
      "name": "suggestedRequestTypes",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "recentFormsListItem_on_RequestForm"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iconUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HelpLayoutSuggestedRequestFormsListElement",
  "abstractKey": null
};

(node as any).hash = "8b20afe5c769c9988ec828c5a8024d42";

export default node;
